import React from 'react';
import { Link, navigate } from '@reach/router';
import Shape3D from 'react-paella-shape-isometric';
import LevelBadge from './level-badge';

function FooterBar() {
  return (
    <footer className="row-between align-center">
      <div className="col-between align-center">
        <Shape3D.Pyramid
          scaling={0.9}
          borderColor={'rgb(43, 44, 48)'}
          borderWidth={2}
          chartBg={'transparent'}
          boundaryX={-6}
        />

        <br aria-hidden="true" />
        <p className="pill-button">
          <Link to="archive">ARCHIVO</Link>
        </p>
      </div>
        <LevelBadge shade="rgba(255, 20, 87, 0.1)" />
      <div className="col-between align-center">
        <Shape3D.Tent
          borderColor={'rgb(43, 44, 48)'}
          borderWidth={2}
          chartBg={'transparent'}
          scaling={0.8}
          boundaryX={-10}
        />
        <br aria-hidden="true" />

        <p className="pill-button">
          <Link to="profile">VESTUARIO</Link>
        </p>
      </div>
    </footer>
  );
}

export default FooterBar;
